import { useState } from "react";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
const Tab2 = ({ SupplierPrimaryAddress, SupplierPrimaryContact }) => {
  return (

    <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Primary Address</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                    // list={SupplierPrimaryAddress.SupplierPrimaryAddress_list}

                    label="Supplier Primary Address"
                    getOptionLabel={(item) =>
                      item.isNew ? "+ Create New Address" : item.name
                    }
                    getOptionValue={(item) => item.name}
                    createNewUrl="/master/address/create-address"
                    createNewLabel="Create New Address"
                    value={SupplierPrimaryAddress.value}
                    onChange={(val) => SupplierPrimaryAddress.setValue(val)}
                  />
                  <p
                    style={{
                      // paddingLeft: "14px",
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      fontSize: "9px",
                      lineHeight: '2',
                      letterSpacing: "0",
                      color: "#2C2B31",
                      fontFamily: "Roboto, sans-serif",
                    }}
                  >
                    Reselect, if the chosen address is edited after save
                  </p>

                </div>
              </div>


            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Primary Contact</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                  <SelectSearch
                    // list={SupplierPrimaryContact.SupplierPrimaryContact_list}

                    label="Supplier Primary Contact"
                    getOptionLabel={(item) =>
                      item.isNew ? "+ Create New Contact" : item.name
                    }
                    getOptionValue={(item) => item.name}
                    createNewUrl="/master/create-contact"
                    createNewLabel="Create New Contact"
                    value={SupplierPrimaryContact.value}
                    onChange={(val) => SupplierPrimaryContact.setValue(val)}
                  />
                  <p
                    style={{
                      // paddingLeft: "14px",
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      lineHeight: '2',
                      fontSize: "9px",
                      letterSpacing: "0",
                      color: "#2C2B31",
                      fontFamily: "Roboto, sans-serif",
                    }}
                  >
                    Reselect, if the chosen contact is edited after save
                  </p>


                </div>

              </div>




            </div>
          </div>
        </div>
        
      </div>

    </div>


  );
};

export default Tab2;
